module.exports = __webpack_public_path__ + "media/images/swifticons/hexagon-c0316a2a3841675c9425747bd132e702.png";